import { useState } from 'react';

const EMAIL = 'zongheng.b.he@gmail.com';

export function EmailCopy({ value = EMAIL, className = '', label, ...rest }) {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      /* clipboard unavailable — copy gracefully no-ops */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <button
      type="button"
      className={`email-copy ${className} ${copied ? 'is-copied' : ''}`.trim()}
      onClick={onClick}
      title="Click to copy"
      {...rest}
    >
      <span className="email-copy__text">{copied ? 'Copied ✓' : (label ?? value)}</span>
    </button>
  );
}
